import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'app-error-modal',
  imports: [],
  template: `
    <div class="modal fade" id="errorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-3 shadow-sm">
          <div class="modal-header border-bottom">
            <h5 class="modal-title text-neutrals-800 fw-bold" id="errorModalLabel">Error</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onClose()"></button>
          </div>
          <div class="modal-body text-center py-4">
            <div class="d-flex justify-content-center mb-3">
              <div class="rounded-circle bg-danger bg-opacity-10 p-4">
                <img src="assets/icons/exclamation-octagon-fill.svg" alt="Error Icono" class="img-fluid" style="max-width: 120px; height: 120px; filter: invert(27%) sepia(97%) saturate(5533%) hue-rotate(350deg) brightness(85%) contrast(93%);" />
              </div>
            </div>
            <p class="text-neutrals-800 mb-3">{{ modalService.errorMessage$() }}</p>
          </div>
          <div class="modal-footer border-top">
            <button type="button" class="btn btn-primary-300 fw-bold rounded-pill w-100" data-bs-dismiss="modal" (click)="onClose()">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './error-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  protected modalService = inject(ModalService);

  onClose(): void {
    this.modalService.hideError();
  }
}
